// extracted by mini-css-extract-plugin
export default {"Modal":"bcg_a bhi_bk bhi_bl bhi_bm bhi_bo bhi_bn bhi_wl","Modal__backdrop":"bcg_b bcg_a bhi_bk bhi_bl bhi_bm bhi_bo bhi_bn bhi_wl bhi_ee"};